import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, getHtmlElementFromEditText, getHtmlFromTexElement, restoreSelection, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontLetterSpacingResolver = ( element: IElement, value?: number, textSelectionInformation?: ITextSelectionInformation, restoreTextSelection?: boolean ):IElement => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("letterSpacing", (element.attributes as ITextAttributes), textSelectionInformation, value, restoreTextSelection);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}

export const fontLineHeightResolver = ( element: IElement, value?: number, textSelectionInformation?: ITextSelectionInformation, restoreTextSelection?: boolean ):IElement => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("lineHeight", (element.attributes as ITextAttributes), textSelectionInformation, value, restoreTextSelection);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    const editElement = getHtmlElementFromEditText();
    if (editElement) {
        const html = getHtmlFromTexElement(element.attributes);
        editElement!.innerHTML = html;
        if (textSelectionInformation && restoreTextSelection) {
            restoreSelection(editElement, textSelectionInformation.start, textSelectionInformation.length);
        }
    }
    return element;
}